var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-ui-speechbubblewithcharacter"},[_c('img',{attrs:{"alt":"Character","height":"135","src":require("@/Asset/image/graphic/avatar-00.webp")}}),_c('ViewUiSpeechBubble',{ref:"speechBubble"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }